export function closeIframe(): void {
  window.parent.postMessage(
    {
      Name: 'close_application',
      Body: null,
      Origin: 'GAME',
      Type: 'NOTIFICATION'
    },
    '*'
  )
}

export function isInIframe(): boolean {
  return typeof window !== 'undefined' && window.top !== window.self
}
